/**
 *Created by Heqi on 2018/1/25.
 */

import { AbstractSearchArgument } from '.././global'
import { CONDITION_TYPE, DATE_PICKER_SHOW_TYPE } from '@/utils/constants'

const SEARCH_CONDITION = [
  {
    name: 'time',
    title: '创建时间',
    placeholder: '',
    type: CONDITION_TYPE.DATE,
    value: '',
    visible: true,
    config: {
      type: DATE_PICKER_SHOW_TYPE.DATE_RANGE,
      format: 'yyyy-MM-dd',
      valueFormat: 'yyyy-MM-dd'
    }
  },
  {
    name: 'dataGroup',
    title: '时间维度',
    placeholder: '请选择',
    type: CONDITION_TYPE.SELECT,
    value: '按天',
    visible: true,
    config: {
      list: [
        {value: '1', label: '按天'},
        {value: '2', label: '按周'},
        {value: '3', label: '按月'}
      ]
    }
  },
  {
    name: 'itemId',
    title: '项目名称',
    placeholder: '请选择您的项目',
    type: CONDITION_TYPE.SELECT,
    value: '',
    visible: true,
    config: {
      list: []
    }
  },
  {
    name: 'repeatFiltering',
    title: '重复与无效',
    placeholder: '请选择',
    type: CONDITION_TYPE.SELECT,
    value: '过滤',
    visible: true,
    config: {
      list: [
        {value: '1', label: '过滤'},
        {value: '2', label: '不过滤'}
      ]
    }
  }]

class SearchArgument extends AbstractSearchArgument {
  constructor () {
    super()

    this.startTime = ''
    this.endTime = ''
    this.itemId = ''
    this.dataGroup = ''
    this.repeatFiltering = ''
  }
}

export {
  SEARCH_CONDITION,
  SearchArgument
}



// WEBPACK FOOTER //
// ./src/models/client/receive-list.js